import './App.css';
// import Interface from "./Interface-test";
import Interface from "./Interface";
// import { AmazonConnectApp } from "@amazon-connect/app";

import 'amazon-connect-streams';
import 'amazon-connect-chatjs';

// AmazonConnectApp.init({
//   onCreate: (event) => {
//     const { appInstanceId } = event.context;
//     console.log("Multilingue initialized: ", appInstanceId);
//   },
//   onDestroy: (event) => {
//     console.log(event);
//   },
// });

function App() {
  return (
    <>
      <Interface></Interface>
    </>
  )
}

export default App
